import { Component, OnInit } from '@angular/core';
import { Briefcase } from '../../../../models/ui/briefcase.model';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BriefcaseManager } from '../../../../managers/briefcase.manager';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'lex-edit-briefcase',
    templateUrl: './edit-briefcase.component.html',
    styleUrls: ['./edit-briefcase.component.scss'],
    standalone: false
})
export class EditBriefcaseComponent implements OnInit {
	public briefcase: Briefcase;
	public briefcaseFormGroup: UntypedFormGroup;

	private subscription: Subscription = new Subscription();

	constructor(private fb: UntypedFormBuilder,
				private activatedRoute: ActivatedRoute,
				private briefcaseManager: BriefcaseManager,
				private router: Router,
				private matSnackBar: MatSnackBar
	) {
		const subscription = this.briefcaseManager.currentBriefcase$.subscribe((briefcase) => {
			this.briefcase = briefcase;
			if (briefcase) {
				this.initializeForm(briefcase);
			}
		});
		this.subscription.add(subscription);
	}

	ngOnInit(): void {
		this.briefcaseManager.setCurrentBriefcase(this.activatedRoute.snapshot.params?.id);
	}

	public isSaveDisabled(): boolean {
		return this.briefcaseFormGroup.invalid || this.briefcaseFormGroup.pristine;
	}

	public save(): void {
		this.briefcaseManager.saveBriefcase(this.briefcase).subscribe(() => {
			this.matSnackBar.open('Briefcase saved successfully', 'X', {
				duration: 3000
			});
			this.router.navigate(['/', 'case', 'download-briefcase']);
		});
	}

	public cancel(): void {
		this.router.navigate(['/', 'case', 'download-briefcase']);
	}

	public viewDocuments(): void {
		this.router.navigate(['/', 'review', 'browse'], {
			queryParams: {
				BriefcaseJobId: this.briefcase.id
			}
		});
	}

	private initializeForm(briefcase: Briefcase): void {
		this.briefcaseFormGroup = this.fb.group({
			title: [briefcase.title, [Validators.required]],
			comments: [briefcase.comments],
			isShared: [briefcase.isShared],
		});

		const subscription = this.briefcaseFormGroup.valueChanges.subscribe((newValue) => {
			this.briefcase.title = newValue.title;
			this.briefcase.comments = newValue.comments;
			this.briefcase.isShared = newValue.isShared;
		});

		this.subscription.add(subscription);
	}

}
